__turbopack_context__.v({
  "card": "UQWvqW_card",
  "figure": "UQWvqW_figure",
  "imageWrapper": "UQWvqW_imageWrapper",
  "root": "UQWvqW_root",
  "section": "UQWvqW_section",
  "title": "UQWvqW_title",
});
